class OfferBox
    constructor: (el) ->
        @.$el = el

        @.$el.classList.add 'offer-box--bound'
        @.InitEvents()
        return
    
    InitEvents: ->
        return

BindOfferBoxes = ->
    document.querySelectorAll '.offer-box:not(.offer-box--bound)'
        .forEach (el) ->
            new OfferBox el
            return
    return

window.addEventListener 'bind-components', BindOfferBoxes

class OfferBoxCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.disciplineId = options?.disciplineId ? false
        @.link = options?.link ? "#{ window.location.origin }#jobs"
        @.locationId = options?.locationId ? false
        @.offerId = options?.offerId ? false
        @.offices = options?.offices ? false
        @.subline = options?.subline ? false
        @.tabIndex = options?.tabIndex ? 2
        @.title = options?.title ? "Keine Angabe"
        @.unspecific = options?.unspecific ? false

        @.CreateElement()
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement 'a'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        @.$el.classList.add 'offer-box'
        if @.unspecific
            @.$el.classList.add 'offer-box--unspecific'
        if @.disciplineId
            @.$el.dataset.discipline = @.disciplineId
        if @.locationId
            @.$el.dataset.location = @.locationId
        if @.offerId
            @.$el.dataset.offerId = @.offerId
            @.$el.classList.add 'overlay--opener'
            @.link = "#{ window.location.origin }?offer=#{@.offerId}"
        if @.offices
            @.$el.dataset.offices = @.offices
        @.$el.href = @.link
        @.$el.tabindex = @.tabIndex
        @.$el.innerHTML = "
            #{ if @.subline && @.subline != "" then "<div class='offer-box__subline'>#{ @.subline }</div>" else "" }
        "
        @.$el.prepend window.CreateHeadline {
            attrs: {
                class: ['offer-box__title']
            },
            level: 4,
            size: 7,
            text: @.title
        }
        return

window.CreateOfferBox = (options) ->
    return new OfferBoxCreate options
